import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const field = "h-10 px-3 rounded-lg bg-[#ffffff] border border-[#e3e2dc] text-sm outline-none focus:border-[#ff2a85]/60 transition-colors w-full";
const label = "font-mono-d text-[9px] uppercase tracking-[0.2em] text-[#5f5e5a] block mb-1";

const FIELDS = [
  ["default_pct", "Default rate %", "Commission on profit for every new ambassador"],
  ["tier_pct", "Tier rate %", "Rate once the tier is reached"],
  ["tier_pieces", "Tier after (pieces)", "Pieces sold to unlock the tier rate"],
  ["fee_pct", "Card fee %", "Estimated processing fee deducted from profit"],
  ["fee_fixed_cents", "Card fee fixed (¢)", "Fixed fee per order, split across its pieces"],
  ["cookie_days", "Link memory (days)", "How long a visitor stays credited to the link"],
];

/** Program-wide commission rules. Changes apply to commissions created from now on. */
export const AmbassadorSettings = ({ headers }) => {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { axios.get(`${API}/admin/ambassadors/settings`, { headers }).then((r) => setS(r.data)).catch(() => toast.error("Could not load settings")); }, [headers]);
  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const body = Object.fromEntries(FIELDS.map(([k]) => [k, Number(s[k])]));
      const r = await axios.put(`${API}/admin/ambassadors/settings`, body, { headers });
      setS(r.data);
      toast.success("Program settings saved");
    } catch (err) {
      toast.error(err?.response?.data?.detail?.[0]?.msg || err?.response?.data?.detail || "Save failed");
    } finally {
      setSaving(false);
    }
  };
  if (!s) return <div className="py-10 flex justify-center"><Loader2 className="animate-spin text-[#5f5e5a]" /></div>;
  return (
    <form data-testid="ambassador-settings" onSubmit={save} className="rounded-3xl border border-[#e3e2dc] bg-[#faf9f6] p-5 sm:p-6">
      <div className="flex items-baseline justify-between gap-4 flex-wrap">
        <div>
          <p className="font-display font-extrabold uppercase text-sm">Program rules</p>
          <p className="mt-1 text-xs text-[#5f5e5a]">Commission = (price − cost − card fee) × rate, per piece. Set each product's cost under Products → option → Cost $.</p>
        </div>
        <button type="submit" data-testid="ambassador-settings-save" disabled={saving} className="h-10 px-5 rounded-full bg-[#0a0a0b] hover:bg-[#ff2a85] disabled:opacity-50 text-white font-mono-d text-[10px] uppercase tracking-[0.2em] transition-colors flex items-center gap-2">{saving ? <Loader2 size={13} className="animate-spin" /> : <Save size={13} />} Save</button>
      </div>
      <div className="mt-5 grid grid-cols-2 lg:grid-cols-6 gap-3">
        {FIELDS.map(([k, l, help]) => (
          <div key={k}><span className={label} title={help}>{l}</span><input data-testid={`amb-setting-${k}`} type="number" step="any" min="0" className={field} value={s[k]} onChange={(e) => setS({ ...s, [k]: e.target.value })} /></div>
        ))}
      </div>
    </form>
  );
};
